import { staticText } from '../../../utils/translations/staticText';

export const moneyHeroTranslation = staticText({});
